import { EncodingOperation } from "./EncodingOperation";
import { IStorage } from "./IStorage";

export class IStorageCookie extends IStorage
{
    private fixed: { [name: string]: string };
    private cookies?: string;
    constructor(fixed: { [name: string]: string }, cookies?: string)
    {
        super();
        this.fixed = fixed;
        this.cookies = cookies;
    }
    private getAll(): { [name: string]: string }
    {
        let ans: { [name: string]: string } = {};
        let items = (this.cookies ?? document.cookie).split(";");
        for (let i = 0; i < items.length; i++)
        {
            const ops = items[i].split("=");
            ans[ops[0].trim()] = ops[1]?.trim().replace(/\%3D/gm, "=");
        }
        return ans;
    }
    override get(name: string, defaultValue: string)
    {
        try
        {
            let all = this.getAll();
            return EncodingOperation.Base64Decode(all[name]) ?? defaultValue;
        } catch (error)
        {
            return defaultValue;
        }
    }
    override set(name: string, value: string)
    {
        try
        {
            let items = [];
            for (let key of Object.keys(this.fixed))
                items.push(`${key}=${this.fixed[key]}`);
            items.push(`${name}=${EncodingOperation.Base64Encode(value)}`);
            document.cookie = items.join(";");
        } catch (error)
        {
        }
    }
    override del(name: string)
    {
        this.set(name, "");
    }
}